export const BAR_SIZE = 6
